import React from 'react'
import IconBegin from '../../images/mywk/icon-begin.png'
import IconStudy from '../../images/mywk/icon-study.png'


class ListenListItem extends React.Component {
    render() {
        const {type, data, itemIndex} = this.props
        return(
            <div className="listenList-item-content">
                <div className="listen-list-item">
                    {type === 'channel' &&
                    <div className="channel-listen-item" onClick={() => location.href = `/channel/${data.channel.channel_id}?fr=access&test=oldwk`}>
                        <div className="channel-listen-item__header">
                            <div className="channel-listen-item__img-bd">
                                {data.lecturer_headimgurl ?
                                    <img className="channel-listen-item__img" src={data.lecturer_headimgurl}/>
                                    :
                                    <img className="channel-listen-item__img" src={data.channel.channel_headingimgurl}/>
                                }
                            </div>
                            <div className="channel-listen-item__right-text">
                                <p className="channel-listen-item__title" style={{WebkitBoxOrient: 'vertical'}}>{data.channel.channel_name}</p>
                            </div>
                        </div>
                        <div className="channel-listen-item__body">
                            {data.name &&
                            <div className="channel-listen-item__body_lecture">
                                <img className="channel-listen-item__icon-img" src={IconStudy}/>
                                <span className="channel-listen-item__lecture">{data.name}</span>
                                <span className="channel-listen-item__progress fr">{data.learning_rate.toFixed(0)}%</span>
                            </div>
                            }
                            {data.channel.starting_lecture &&
                            <div className="channel-listen-item__body_lecture">
                                <img className="channel-listen-item__icon-img" src={IconBegin}/>
                                <span className="channel-listen-item__lecture">{data.channel.starting_lecture.name}</span>
                            </div>
                            }
                        </div>
                    </div>
                    }

                    {type === 'lecture' &&
                    <div className="lecture-listen-item" onClick={() => data.lecture_mode === 'default' ? location.href = `/classroom/${data.id}?test=oldwk` : location.href = `/lecture/${data.id}?test=oldwk`}>
                        <div className="lecture-listen-item__img">
                            <img className="channel-listen-item__img" src={data.lecturer_headimgurl}/>
                        </div>
                        <div className="lecture-listen-item__content">
                            <p className="lecture-listen-item__title">单课</p>
                            <div className="lecture-listen-item__ft">
                                <span className="lecture-listen-item__text wk-clamp-line">{data.name}</span>
                                <span className="channel-listen-item__progress fr">{data.learning_rate.toFixed(0)}%</span>
                            </div>
                        </div>
                    </div>
                    }
                </div>

                {/* {itemIndex === 5 &&
                <div onClick={() => window.location = `/specials/coupon?bagid=20&is_hide_prize=1&inviter_id=44814415`}>
                    <img src="https://static-1253442168.file.myqcloud.com/xupload/20180709_icon-redpack.png" alt="" width="100%"/>
                </div>
                } */}
            </div>
        )
    }
}

export default ListenListItem


// WEBPACK FOOTER //
// ./src/pages/mywkPage/ListenListItem.js